import { render } from "./staffSection.vue?vue&type=template&id=059090a9&scoped=true"
import script from "./staffSection.vue?vue&type=script&lang=js"
export * from "./staffSection.vue?vue&type=script&lang=js"

import "./staffSection.vue?vue&type=style&index=0&id=059090a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059090a9"]])

export default __exports__